'use client';

/* eslint-disable @next/next/no-img-element */

import { ImgHTMLAttributes } from 'react';
import useRenderableImageSrc from '@/hooks/use-renderable-image-src';
import { buildGumletUrl } from '@/utils/gumlet';

type RenderableImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
};

export const RenderableImage = ({ src, alt, width, height, ...props }: RenderableImageProps) => {
  const optimizedSrc = buildGumletUrl(src, {
    width: typeof width === 'number' ? width : undefined,
    height: typeof height === 'number' ? height : undefined,
  });
  const renderableSrc = useRenderableImageSrc(optimizedSrc);

  if (!renderableSrc) {
    return null;
  }

  return <img src={renderableSrc} alt={alt} width={width} height={height} {...props} />;
};
